import apiSerialConvert from '@/api/serialConvert';

const defaultState = () => ({
	listSerialConvert: [],
	detailSerialConvert: {},
	serialConvertPagination: {},
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
	
};

const mutations = {
	setSerialConvert(state, data) {
		state.listSerialConvert = data.data
		state.serialConvertPagination = data.pagination;
	},
	setDetailSerialConvert(state, data) {
		state.detailSerialConvert = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = []
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataSerialConvert(state) {
		Object.assign(state, defaultState())
	},
};

const actions = {
	getSerialConvert({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSerialConvert.getSerialConvert(params).then(({ data: { data } }) => {
				commit('setSerialConvert', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getSerialConvertAll({ dispatch, commit }, params) {
		return new Promise((resolve) => {
			apiSerialConvert.getSerialConvertAll(params).then(({ data: { data } }) => {
				commit('setSerialConvert', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
			});
		});
	},
	getDetailSerialConvert({ commit, dispatch }, params) {
		apiSerialConvert.getDetailSerialConvert(params).then(({ data: { data } }) => {
			commit('setDetailSerialConvert', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailSerialConvert', { data: [] });
		});
	},
	getSerialConvertRoam({ dispatch, commit }) {
		apiSerialConvert.getSerialConvertRoam().then(({ data: { data } }) => {
			if (data.results.length == 0) {
				commit('setSerialConvert', { data: [] });
			} else {
				commit('setSerialConvert', { data: data.results });
			}
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
		});
	},
	async exportSerialConvert({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSerialConvert.exportSerialConvert(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Delivery Order'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportSerialConvertAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiSerialConvert.exportSerialConvertAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Sales Delivery Order Warehouse'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async approveSerialConvert({ commit, dispatch }, params) {
		await apiSerialConvert.approveSerialConvert(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	scanSerial({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSerialConvert.scanSerial({
				serial: params.serial,
				card_type: params.card_type,
				is_serial: params.type,
				arr_serial: params.arr_serial,
			}).then( ( { data : { data } } ) => {
				var serialSuccess = data.results.filter((el) => {
					return el.status == "available" && el.type == params.type
				})

				var serialFailed = data.results.filter((el) => {
					return el.status != "available" || el.type != params.type
				})
				var res = {
					success: serialSuccess.map((el) => {
						return el.serial
					}),
					failed : serialFailed.reduce((r, a) => {
						r[a.note] = [...r[a.note] || [], a.serial];
						return r;
					}, {})
				}
				if (serialSuccess.length > 0)
					resolve(res)
				else
					reject(res)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};